<template>
  <button
    type="button"
    :aria-pressed="selected"
    class="flex items-center gap-3 px-3.5 py-3 rounded-sm border text-left min-w-0 text-blue-whale transition-colors"
    :class="selected ? 'border-blue-whale bg-neutral-lightest' : 'border-java-light bg-white hover:bg-neutral-lightest'"
    @click="$emit('select')"
  >
    <span class="w-10 h-10 flex-none rounded-sm flex items-center justify-center" :class="selected ? 'bg-blue-whale text-white' : 'bg-neutral-lightest text-accent'">
      <slot name="icon" />
    </span>
    <span class="flex-1 min-w-0 font-semibold text-base leading-tight">{{ label }}</span>
    <svg v-if="selected" class="w-[22px] h-[22px] flex-none text-accent" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="m8 12.5 2.5 2.5L16 9.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>
</template>

<script setup lang="ts">
  defineProps<{ label: string; selected: boolean }>();
  defineEmits<{ (e: 'select'): void }>();
</script>
